<script setup lang="ts">
</script>

<template>
  <div class="custom-header">
    <portalLayoutPart part="header" />
  </div>
</template>

<style lang="scss" scoped>
.custom-header {
  position: relative;
  min-height: 72px;
  background: #fff;
  min-width: 1190px;
}
</style>
